module.exports = __webpack_public_path__ + "img/teacherStudentSearch.10c6a1b9.png";